/**
 * Tâche 1443 (Eric 2026-10-02) — Liste d'exclusion.
 *
 * « Un nom propre de client n'est pas une faute. » L'exclusion gagne sur toute
 * variante, y compris celles qu'on a validées : c'est le seul moyen de garder
 * « Hétu » hors du rapport sans retirer la variante qui, ailleurs, est juste.
 */
import { useState } from "react";
import { Plus, ShieldCheck, X } from "@phosphor-icons/react";
import { useLang } from "../../contexts/LanguageContext";

export const ListeExclusions = ({ exclusions, onAjouter, onRetirer }) => {
  const { tr } = useLang();
  const [saisie, setSaisie] = useState("");

  const ajouter = async () => {
    const propre = saisie.trim();
    if (!propre) return;
    await onAjouter(propre);
    setSaisie("");
  };

  return (
    <div className="border border-zinc-200 bg-white rounded-xl p-4"
         data-testid="orthographe-exclusions">
      <div className="flex items-center gap-2 mb-1">
        <ShieldCheck size={16} className="text-emerald-600" weight="duotone" />
        <h3 className="text-sm font-semibold text-zinc-900">
          {tr("Noms à ne jamais signaler", "Names never to be flagged")}
        </h3>
      </div>
      <p className="text-[11px] text-zinc-500 mb-3">
        {tr("Noms propres de clients, de produits ou de partenaires. Ils sont écartés du balayage ET annoncés à l'IA, pour qu'elle ne les « corrige » pas.",
            "Client, product or partner proper nouns. They are excluded from the scan AND declared to the AI, so that it never \"corrects\" them.")}
      </p>

      <div className="flex flex-wrap gap-2 mb-3">
        {exclusions.length === 0 && (
          <p className="text-xs text-zinc-400">
            {tr("Aucun nom exclu pour l'instant.", "No excluded name yet.")}
          </p>
        )}
        {exclusions.map((e) => (
          <span key={e.id}
                className="inline-flex items-center gap-1 bg-emerald-50 border border-emerald-200 rounded-full pl-2.5 pr-1 py-0.5 text-xs text-emerald-900"
                data-testid={`orthographe-exclusion-${e.id}`}>
            {e.terme}
            <button
              type="button"
              onClick={() => onRetirer(e.id)}
              className="p-1 rounded-full text-emerald-600 hover:bg-white"
              data-testid={`orthographe-exclusion-retirer-${e.id}`}
              title={tr("Retirer de la liste", "Remove from the list")}
            >
              <X size={12} />
            </button>
          </span>
        ))}
      </div>

      <div className="flex items-center gap-2">
        <input
          value={saisie}
          onChange={(e) => setSaisie(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") ajouter(); }}
          placeholder={tr("Ex. : Hétu, Desjardins, SunLife", "E.g.: Hétu, Desjardins, SunLife")}
          className="flex-1 min-w-0 px-3 py-1.5 border border-zinc-300 rounded-md text-xs focus:outline-none focus:ring-1 focus:ring-[#002FA7]"
          data-testid="orthographe-exclusion-champ"
        />
        <button
          type="button"
          onClick={ajouter}
          disabled={!saisie.trim()}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md bg-zinc-800 text-white text-xs font-medium hover:bg-zinc-900 transition-colors disabled:opacity-40"
          data-testid="orthographe-exclusion-ajouter"
        >
          <Plus size={13} />
          {tr("Exclure", "Exclude")}
        </button>
      </div>
    </div>
  );
};

export default ListeExclusions;
